import { ReactNode, useEffect } from 'react';

import { useInView } from 'react-intersection-observer';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { useAvroTracking } from './avro';

export function ScrollTracking({
  avroIdentifier,
  children,
  preAvroIdentifier,
  ...rest
}: {
  avroIdentifier: string;
  children: ReactNode;
  preAvroIdentifier?: string;
}) {
  const trackEvent = useTrackEvent();
  const { emitInViewEvent } = useAvroTracking();

  const [ref, inView] = useInView({
    fallbackInView: false,
  });

  useEffect(() => {
    if (inView) {
      emitInViewEvent({
        custom_tracking_fields: {
          component: avroIdentifier,
        },
      });

      if (preAvroIdentifier) {
        trackEvent('component_scrolled_into_view', {
          component: preAvroIdentifier,
        });
      }
    }
  }, [avroIdentifier, emitInViewEvent, inView, preAvroIdentifier, trackEvent]);

  return (
    <div ref={ref} {...rest}>
      {children}
    </div>
  );
}
